export const LOGIN = "/login";
export const ACCOUNT_VERIFICATION = "/account/verification/:token";
export const UNAUTHORIZED_ACCESS = "/unauthorized"

// disciplines
export const DISCIPLINES_LIST = "/manage-disciplines/discipline-profiles";
export const DISCIPLINES_ADD = "/manage-disciplines/discipline-profiles/add";
export const DISCIPLINES_EDIT = "/manage-disciplines/discipline-profiles/edit/:id";

// goals
export const GOALS_LIST = "/manage-goals";
export const GOALS_ADD = "/manage-goals/add";
export const GOALS_EDIT = "/manage-goals/edit/:id";

// designations
export const DESIGNATIONS_LIST = "/designations";
export const DESIGNATIONS_ADD = "/designations/add";
export const DESIGNATIONS_EDIT = "/designations/edit/:id";

// Therapist Profiles
export const THERAPIST_LIST = "/manage-team/therapist-profiles";
export const THERAPIST_ADD = "/manage-team/therapist-profiles/add";
export const THERAPIST_EDIT = "/manage-team/therapist-profiles/edit/:id";
export const THERAPIST_DETAIL = "/manage-team/therapist-profiles/detail/:id";
export const THERAPIST_ASSIGNED_CLIENTS = "/manage-team/therapist-profiles/assigned-clients/:id";

// School divisons
export const SCHOOL_DIVISON_LIST = "/manage-schools/school-division";
export const SCHOOL_DIVISON_ADD = "/manage-schools/school-division/add";
export const SCHOOL_DIVISON_EDIT = "/manage-schools/school-division/edit/:id";

// School profiles
export const SCHOOL_LIST = "/manage-schools/school-profiles";
export const SCHOOL_ADD = "/manage-schools/school-profiles/add";
export const SCHOOL_EDIT = "/manage-schools/school-profiles/edit/:id";

// School Clients
export const SCHOOL_CLIENT_LIST = "/client/school";
export const SCHOOL_CLIENT_ADD = "/client/school/add";
export const SCHOOL_CLIENT_EDIT = "/client/school/edit/:id";
export const SCHOOL_CLIENT_DETAIL = "/client/school/detail/:id";

// Home Education
export const HOME_EDUCATION_LIST = "/client/home-education";
export const ADD_HOME_EDUCATION = "/client/home-education/add";
export const EDIT_HOME_EDUCATION = "/client/home-education/edit/:id";
export const VIEW_HOME_EDUCATION = "/client/home-education/detail/:id";
export const HOME_EDUCATION_CREATE_INTAKE_REPORT = "/client/home-education/intake-report/:id";
export const HOME_EDUCATION_CREATE_INTAKE_REPORT_V2 = "/client/home-education/intake-report-v2/:id";

// Private Clients
export const ADD_PRIVATE_CLIENT = "/client/private/add";
export const PRIVATE_CLIENT_LIST = "/client/private";
export const EDIT_PRIVATE_CLIENT = "/client/private/edit/:id";
export const VIEW_PRIVATE_CLIENT = "/client/private/detail/:id";

// Discharges
export const DISCHARGES = '/discharges';
export const CLASSROOM_CONSULTATIONS = '/classroom-consultation';

// Chatter Clients
export const CHATTER_CLIENT_LIST = "/client/chatter";
export const ADD_CHATTER_CLIENT = "/client/chatter/add";
export const EDIT_CHATTER_CLIENT = "/client/chatter/edit/:id";
export const VIEW_CHATTER_CLIENT = "/client/chatter/detail/:id";
export const CHATTER_CLIENT_ATTENDANCE = "/client/chatter/detail/attendance/:id";

// Funding Source
export const FUNDING_SOURCE_LIST = "/manage-private-clients/funding-sources";
export const ADD_FUNDING_SOURCE = "/manage-private-clients/funding-sources/add";
export const EDIT_FUNDING_SOURCE = "/manage-private-clients/funding-sources/edit/:id";
export const VIEW_FUNDING_SOURCE = "/manage-private-clients/funding-sources/detail/:id";

// Manage status
export const MANAGE_STATUS_LIST = "/client/manage-status";
export const MANAGE_STATUS_ADD = "/client/manage-status/add";
export const MANAGE_STATUS_EDIT = "/client/manage-status/edit/:id";

// Manage Chatter Program
export const CHATTER_PROGRAM_LIST = "/manage-chatter/program-profiles";
export const CHATTER_PROGRAM_ADD = "/manage-chatter/program-profiles/add";
export const CHATTER_PROGRAM_EDIT = "/manage-chatter/program-profiles/edit/:id";
export const CHATTER_PROGRAM_DETAILS = "/manage-chatter/program-profiles/detail/:id";

// Manage Chatter Lessons
export const CHATTER_LESSON_LIST = "/manage-chatter/lesson-plans";
export const CHATTER_LESSON_ADD = "/manage-chatter/lesson-plans/add";
export const CHATTER_LESSON_EDIT = "/manage-chatter/lesson-plans/edit/:id";
export const CHATTER_LESSON_DETAILS = "/manage-chatter/lesson-plans/detail/:id";
export const CHATTER_LESSON_TAGS = '/tags'

// Manage Chatter Peer
export const CHATTER_PEER_LIST = "/manage-chatter/chatter-peers";
export const CHATTER_PEER_ADD = "/manage-chatter/chatter-peers/add";
export const CHATTER_PEER_EDIT = "/manage-chatter/chatter-peers/edit/:id";
export const CHATTER_PEER_DETAILS = "/manage-chatter/chatter-peers/detail/:id";
export const CHATTER_PEER_REFERENCE_LETTER = "/manage-chatter/chatter-peers/reference-letter/:id";
export const CHATTER_PEER_REFERENCE_LETTER_V2 = "/manage-chatter/chatter-peers/reference-letter-v2/:chatterId";


// Manage MDT Assesment
export const MDT_ASSESSMENT_LIST = "/manage-mdt/multidisciplinary-assessment";
export const MDT_ASSESSMENT_ADD = "/manage-mdt/multidisciplinary-assessment/add";
export const MDT_ASSESSMENT_EDIT = "/manage-mdt/multidisciplinary-assessment/edit:id";
export const MDT_ASSESSMENT_DETAILS = "/manage-mdt/multidisciplinary-assessment/detail/:id";
export const MDT_ASSESSMENT_DOCUMENTS = '/manage-mdt/multidisciplinary-assessment/detail/:clientType/:clientId'

// Manage MDT Status
export const MDT_STATUS_LIST = "/manage-mdt/manage-status";
export const MDT_STATUS_ADD = "/manage-mdt/manage-status/add";
export const MDT_STATUS_EDIT = "/manage-mdt/manage-status/edit/:id";

// Manage MDT Terms
export const MDT_TERMS_LIST = "/manage-mdt/mdt-terms";
export const MDT_TERMS_ADD = "/manage-mdt/mdt-terms/add";
export const MDT_TERMS_EDIT = "/manage-mdt/mdt-terms/edit/:id";

// Service Status
export const SERVICE_STATUS_LIST = "/service-status";
export const SERVICE_STATUS_ADD = "/service-status/add";
export const SERVICE_STATUS_EDIT = "/service-status/edit/:id";

// Manage Parents
export const MANAGE_PARENTS_LIST = "/manage-parents";
export const MANAGE_PARENTS_ADD = "/manage-parents/add";
export const MANAGE_PARENTS_EDIT = "/manage-parents/edit/:id";
export const MANAGE_PARENTS_DETAILS = "/manage-parents/details/:id";
export const MANAGE_PARENT_TASKS_LIST = "/manage-parents/tasks/:parentId/:clientId";
export const MANAGE_PARENT_TASK_SESSION_VIEW = '/manage-parents/tasks/session/:parentId/:clientId/:taskId'

// Consent Checklists
export const MANAGE_CONSENT_CHECKLISTS_LIST = '/manage-checklists';
export const MANAGE_CONSENT_CHECKLISTS_ADD = '/manage-checklists/add'
export const MANAGE_CONSENT_CHECKLISTS_UPDATE = '/manage-checklists/edit/:id'


// Manage Parents
export const MANAGE_TEACHERS_LIST = "/manage-teachers";
export const MANAGE_TEACHERS_ADD = "/manage-teachers/add";
export const MANAGE_TEACHERS_EDIT = "/manage-teachers/edit/:id";

// Manage Coordinators
export const MANAGE_COORDINATORS_LIST = "/manage-coordinators";
export const MANAGE_COORDINATORS_ADD = "/manage-coordinators/add";
export const MANAGE_COORDINATORS_EDIT = "/manage-coordinators/edit/:id";

// Manage Parents
export const MANAGE_SUPPORT_STAFF_LIST = "/manage-support-staff";
export const MANAGE_SUPPORT_STAFF_ADD = "/manage-support-staff/add";
export const MANAGE_SUPPORT_STAFF_EDIT = "/manage-support-staff/edit/:id";
export const MANAGE_SUPPORT_STAFF_VIEW = "/manage-support-staff/details/:id";
export const MANAGE_SUPPORT_STAFF_CLIENT_TASKS = '/manage-support-staff/details/:staffId/:clientId'
export const MANAGE_SUPPORT_STAFF_CLIENT_TASKS_SESSION_VIEW = '/manage-support-staff/details/view/:staffId/:clientId/:taskId'
export const MANAGE_STAFF_GROUP_TASK_LIST = "/manage-support-staff/group-tasks/:staffId/:groupId";
export const MANAGE_STAFF_GROUP_SESSION_VIEW = '/manage-support-staff/group-tasks/session/:staffId/:groupId'

//CLIENT CONSENT FORMS 
export const CLIENT_CONSENT_FORMS_LIST = '/manage-parents/client/consent-forms/:parentId/:id/'
export const CLIENT_ASSIGNED_COSNENT_FORMS_VIEW = '/client/consent-forms/view/:id/:mode?'


// Cms
export const MANAGE_CMS_LIST = "/cms";
export const MANAGE_CMS_ADD = "/cms/add";
export const MANAGE_CMS_EDIT = "/cms/edit/:id";

// Email Notification Template
export const MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST = "/manage-email-notification";
export const MANAGE_NOTIFICATION_EMAIL_TEMPLATE_ADD = "/manage-email-notification/add";
export const MANAGE_NOTIFICATION_EMAIL_TEMPLATE_EDIT = "/manage-email-notification/edit/:id";

// Firebase Notification Template
export const MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_LIST = "/manage-firebase-notification";
export const MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_ADD = "/manage-firebase-notification/add";
export const MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_EDIT = "/manage-firebase-notification/edit/:id";

// Sub Admin
export const MANAGE_USERS_LIST = "/manage-users/users";
export const MANAGE_USERS_ADD = "/manage-users/users/add";
export const MANAGE_USERS_EDIT = "/manage-users/users/edit/:id";
export const MANAGE_USERS_VIEW = "/manage-users/users/details/:id";
export const MANAGE_USERS_ROLE = "/manage-users/role";

// Profile
export const PROFILE = "/profile";

// Policy and procedure
export const POLICY_AND_PROCEDURE = "/policy-and-procedures"
export const POLICY_AND_PROCEDURE_PREVIEW = "/policy-and-procedures/preview"
export const POLICY_AND_PROCEDURE_V2 = "/policies-and-procedures"
export const POLICY_AND_PROCEDURE_V2_ADD = "/policies-and-procedures/add"
export const POLICY_AND_PROCEDURE_V2_EDIT = "/policies-and-procedures/edit/:id"
export const POLICY_AND_PROCEDURE_V2_DETAIL = "/policies-and-procedures/detail/:id"


// Manage Export
export const MANAGE_EXPORT = "/manage-export"

// Manage Consent
export const MANAGE_CONSENT_FORM = "/manage-consent-form"
export const MANAGE_CONSENT_ADD = "/manage-consent-form/add"
export const MANAGE_CONSENT_EDIT = "/manage-consent-form/edit/:id"

export const VIEW_REPORT = "/clients/report/:attachmentKey"

//APPOINTMENT
export const APPOINTMENT_ADD = "/appointment/add"
export const APPOINTMENT_LIST = "/appointment/list"
export const APPOINTMENT_DETAILS = "/appointment/details/:id"
export const APPOINTMENT_EDIT = "/appointment/edit/:id";
export const APPOINTMENT_FORMS_VIEW = '/appointment/formview/:id/:mode?'

// Appointment Services 
export const APPOINTMENT_SERVICES_ADD = "/services/add"
export const APPOINTMENT_SERVICES_LIST = "/services/list"
export const APPOINTMENT_SERVICES_EDIT = "/services/edit/:id";

// Appointment Invoices
export const APPOINTMENT_INVOICE_LIST = "/invoices"
export const APPOINTMENT_INVOICE_VIEW = "/invoices/:id"

// Assessment Templates
export const ASSESSMENT_TEMPLATE_ADD = "/assessment-templates/add";
export const ASSESSMENT_TEMPLATE_LIST = "/assessment-templates";
export const ASSESSMENT_TEMPLATE_EDIT = "/assessment-templates/edit/:id";

// Chatter Templates
export const CHATTER_TEMPLATE_ADD = "/chatter-templates/add";
export const CHATTER_TEMPLATE_LIST = "/chatter-templates";
export const CHATTER_TEMPLATE_EDIT = "/chatter-templates/edit/:id";

// Audit Logs
export const AUDIT_LOGS = "/audit-logs"


// CLIPBOARD NOTES
export const NOTES_TABLE = '/notes'
export const CREATE_NOTES = '/notes/add'
export const EDIT_NOTES = '/notes/edit/:id'

// WORKSHOPS
export const WORKSHOPS = '/workshops'
export const WORKSHOP_ADD = '/workshops/add'
export const WORKSHOP_EDIT = '/workshops/edit/:id'
export const WORKSHOP_VIEW = '/workshops/view/:id'

// DAIGNOSIS AND SEVERTIY 
export const DIAGNOSIS_SERVERITY = '/client/:clientType/detail/diagnosis/:clientId'

// SERVICE STATUS 
export const CLIENT_SERVICE_STATUS_LIST = '/client/:clientType/detail/service-status/:clientId'
export const CLINICIANS_HISTORY = '/client/:clientType/detail/clinicians-history/:clientId'

// ATTENDANCE TRACK 
export const CLIENT_ATTENDANCE_LIST = '/client/:clientType/detail/attendance/:clientId'

// ATTENDANCE TRACK 
export const CLIENT_DOCUMENTS_LIST = '/client/:clientType/detail/documents/:clientId'

// REPORTS
export const CLIENT_REPORTS_LIST = '/client/:clientType/detail/reports/:clientId'


// ONBOARD 

export const SUBADMIN_ONBOARD = "/sub-admin/onboard"

// SCHOOL BANNERS
export const SCHOOL_BANNERS_LIST = "/school-banners"
export const SCHOOL_BANNERS_ADD = "/school-banners/add"
export const SCHOOL_BANNERS_EDIT = "/school-banners/edit/:id"
export const SCHOOL_BANNERS_VIEW = "/school-banners/view/:id"

export const NOTIFICATIONS = '/notifications'
export const MANAGE_NOTIFICATIONS = '/manage-notifications'
export const MANAGE_NOTIFICATION_USERS = '/manage-notifications/:category'
export const MANAGE_NOTIFICATION_USER_FEED = '/manage-notifications/:category/:userId'
export const NOTIFICATION_TEMPLATES = '/notification-templates'
export const NOTIFICATION_TEMPLATES_EDIT = '/notification-templates/edit/:id'
